import moment from 'moment';
import axios from '../requester';
import { API } from '../constants/api-urls';
import { SEARCH_DATE_FORMAT } from '../constants/constants';

export const getNotifications = teamId =>
  axios
    .get(`${API.NOTIFICATIONS_PATH}`, {
      params: {
        team_id: teamId,
        state: 'active',
        limit: 21,
        after: moment().subtract(2, 'week').format(SEARCH_DATE_FORMAT)
      }
    })
    .catch(e => ({ items: [], total: 0 }));
export const deactivateNotification = notificationId =>
  axios.patch(`${API.NOTIFICATIONS_PATH}/${notificationId}`, {
    state: 'inactive'
  });
